import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

/* Modified มาจาก
SelectRankingPosition.js 
*/

export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { rhf, control, name, label } = props;

  // โหลดข้อมูลจังหวัดตั้งแต่ component mount
  React.useEffect(() => {
    let active = true;

    (async () => {
      console.log('---call API Province on mount---');

      var config = {
        method: 'get',
        url: '/api/cis/province',
      };

      axios(config)
        .then(function (response) {
          response.data = response.data.filter((category) => category.name);
          if (active) {
            setOptions([...response.data]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    })();

    return () => {
      active = false;
    };
  }, []); // empty dependency = run once on mount


  return (
    <rhf.Controller
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          id="province-select"
          options={options}
          value={field.value || null}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          getOptionLabel={(option) => option.name || ''}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          onChange={(_, data) => field.onChange(data)}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label || 'จังหวัด'}
              variant="filled"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      )}
      name={name}
      control={control}
    />
  );
}
